import { useState, useEffect } from 'react';
import { fetchSettings, saveSettings } from '../controller/settings-controller';

export const useSettingsViewModel = () => {
  const [storeInfo, setStoreInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [notification, setNotification] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      const data = await fetchSettings();
      setStoreInfo({
        codeSociete: data.codeSociete || '',
        societe: data.societe || '',
        matriculeFiscal: data.matriculeFiscal || '',
        adresse: data.adresse || '',
        email: data.email || '',
        tel: data.tel || '',
        fraisDeLivraison: data.fraisDeLivraison || 0,
        lienFacebook: data.lienFacebook || '',     // Fixed: use lienFacebook
        lienInstagram: data.lienInstagram || ''    // Fixed: use lienInstagram
      });
    } catch (error) {
      setError('Failed to load settings. Please try again.');
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveStoreInfo = async (storeInfoData) => {
    try {
      setIsSaving(true);
      setNotification(null);
      
      await saveSettings(storeInfoData);
      
      setNotification({
        type: 'success',
        message: 'Paramètres de l\'entreprise enregistrés avec succès!'
      });

      // Auto-hide notification after 5 seconds
      setTimeout(() => {
        setNotification(null);
      }, 5000);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSaving(false);
    }
  };

  return {
    storeInfo,
    isLoading,
    isSaving,
    notification,
    error,
    handleSaveStoreInfo,
    clearNotification: () => setNotification(null),
    retryLoading: loadSettings
  };
};